"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawableWriter = void 0;
var core_api_1 = require("@ikegps/core-api");
var drawable_1 = require("../drawable/drawable");
var label_drawable_1 = require("../drawable/label.drawable");
var line_drawable_1 = require("../drawable/line.drawable");
var line_point_drawable_1 = require("../drawable/line.point.drawable");
var marker_drawable_1 = require("../drawable/marker.drawable");
var marker_offset_drawable_1 = require("../drawable/marker.offset.drawable");
var mask_drawable_1 = require("../drawable/mask.drawable");
function writeLink(collection, fieldId) {
    var collectionField = null;
    collection.forEachField(function (c) {
        if (c.id === fieldId) {
            collectionField = c;
            return false;
        }
        return true;
    });
    if (collectionField == null) {
        return null;
    }
    var formField = collectionField.schema;
    return {
        name: formField.id,
        formID: collectionField.parent.instanceId,
        text: collectionField.annotationLabel
    };
}
function writeLabelDrawable(label) {
    var state = label.state;
    var text = label.text;
    if (text.length === 1) {
        text = text[0];
    }
    else if (text.length === 0) {
        text = undefined;
    }
    return {
        id: label.id,
        tag: 'label',
        x: drawable_1.CollectionModelDrawable.roundCoord(state.x),
        y: drawable_1.CollectionModelDrawable.roundCoord(state.y),
        text: text
    };
}
function writeMarkerDrawable(collection, drawable) {
    var state = drawable.state;
    var links = drawable.label.links.map(function (field) { return writeLink(collection, field.id); });
    return {
        id: state.id,
        type: state.type,
        x: drawable_1.CollectionModelDrawable.roundCoord(state.x),
        y: drawable_1.CollectionModelDrawable.roundCoord(state.y),
        tag: 'marker',
        label: writeLabelDrawable(drawable.label),
        link: links.length > 0 ? links : undefined,
        position: state.position ? state.position : undefined,
        pair: state.pair ? state.pair : undefined,
        insight: state.insight ? state.insight : undefined
    };
}
function writeBaseMarkerDrawable(collection, drawable) {
    var drawableState = writeMarkerDrawable(collection, drawable);
    if (drawable.state.offset != null) {
        drawableState.offset = drawable.state.offset;
    }
    return drawableState;
}
function writeLineDrawable(collection, drawable) {
    var state = drawable.state;
    var startPoint = drawable.start;
    var endPoint = drawable.end;
    return {
        id: state.id,
        tag: 'line',
        start: { x: drawable_1.CollectionModelDrawable.roundCoord(startPoint.state.x), y: drawable_1.CollectionModelDrawable.roundCoord(startPoint.state.y) },
        end: { x: drawable_1.CollectionModelDrawable.roundCoord(endPoint.state.x), y: drawable_1.CollectionModelDrawable.roundCoord(endPoint.state.y) },
        label: writeLabelDrawable(drawable.label),
        insight: state.insight ? state.insight : undefined
    };
}
function writeMaskDrawable(collection, drawable) {
    var state = drawable.state;
    if (!state) {
        throw new Error('attempting to write a mask without state');
    }
    return {
        id: state.id,
        tag: 'mask',
        pukeko_data: state.pukeko_data
    };
}
var DrawableWriter = /** @class */ (function () {
    function DrawableWriter() {
    }
    DrawableWriter.write = function (collection, drawable) {
        if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
            return writeMarkerDrawable(collection, drawable);
        }
        if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(drawable)) {
            if (drawable.state.type === core_api_1.MarkerType.BASE) {
                return writeBaseMarkerDrawable(collection, drawable);
            }
            return writeMarkerDrawable(collection, drawable);
        }
        if (line_drawable_1.CollectionModelDrawableLine.isLine(drawable)) {
            return writeLineDrawable(collection, drawable);
        }
        if (label_drawable_1.CollectionModelDrawableLabel.isLabel(drawable)) {
            return null;
        }
        if (line_point_drawable_1.CollectionModelDrawableLinePoint.isLinePoint(drawable)) {
            return null;
        }
        if (mask_drawable_1.CollectionModelDrawableMask.isMask(drawable)) {
            return writeMaskDrawable(collection, drawable);
        }
        throw new Error("Unexpected drawable: ".concat(drawable.id, ":").concat(drawable.state.tag));
    };
    return DrawableWriter;
}());
exports.DrawableWriter = DrawableWriter;
//# sourceMappingURL=collection.model.write.drawable.js.map